export default function FileTypeGrid({
  sections,
  selected,
  onToggle,
  onSelectPhase,
  onSelectAll,
  onSelectNone,
  metaClass = 'ft-folder',
  showPhaseActions = true,
}) {
  const togglePhaseHeader = (phaseNum) => {
    const sec = sections.find((s) => s.phase === phaseNum);
    if (!sec) return;
    const keys = sec.items.map((it) => it.value);
    const allOn = keys.every((k) => selected.has(k));
    onSelectPhase(phaseNum, !allOn);
  };

  return (
    <div className="eod-file-type-section">
      <div className="eod-file-type-header">
        <span className="ft-title">Select Data Types (grouped by Phase)</span>
        {showPhaseActions && (
          <div className="ft-actions">
            <button type="button" onClick={() => onSelectPhase(1, true)}>Phase 1</button>
            <button type="button" onClick={() => onSelectPhase(2, true)}>Phase 2</button>
            <button type="button" onClick={() => onSelectPhase(3, true)}>Phase 3</button>
            <button type="button" onClick={onSelectAll}>All</button>
            <button type="button" onClick={onSelectNone}>None</button>
          </div>
        )}
      </div>

      <div className="eod-file-type-grid">
        {sections.map((sec) => (
          <div key={`sec-${sec.phase}`}>
            <div
              className="ft-section-label"
              style={sec.sectionStyle}
              onClick={() => togglePhaseHeader(sec.phase)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') togglePhaseHeader(sec.phase); }}
            >
              <i className={`bi bi-${sec.phase}-circle`} />{' '}
              <b>{sec.section}</b>{' '}
              <span style={{ opacity: 0.7, fontWeight: 400 }}>({sec.sectionHint})</span>
            </div>
            {sec.items.map((it) => (
              <label key={it.value} className="ft-item">
                <input
                  type="checkbox"
                  checked={selected.has(it.value)}
                  onChange={() => onToggle(it.value)}
                />
                <span className="ft-label">{it.label}</span>
                {it.badge === 'api' ? (
                  <span className="ft-badge ft-badge-api">{it.meta}</span>
                ) : (
                  <span className={metaClass}>{it.meta}</span>
                )}
              </label>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}